document.addEventListener('DOMContentLoaded', function() {
    const parallaxImages = document.querySelectorAll('.parallax-image');
    if (parallaxImages.length > 0) {
        window.addEventListener('scroll', function() {
            parallaxImages.forEach(function(image) {
                const sectionTop = image.closest('.parallax-container').offsetTop;
                const scrollPosition = window.scrollY;
                
                // Apply parallax effect only if the section is in view
                if (scrollPosition > sectionTop - window.innerHeight && scrollPosition < sectionTop + image.closest('.parallax-container').offsetHeight) {
                    image.style.transform = `translateY(${(scrollPosition - sectionTop) * 0.5}px)`;
                }
            });
        });
    }
});
